import * as React from 'react'
import { ReactElement } from 'react'
import { Toast, ToastBody, ToastFooter, ToastTitle } from '@fluentui/react-components'
import { EmailFilingParams } from '../../hooks/email/emailFilingTypes'
import ErrorPopover from './ErrorPopover'
import QueueToastActions from './QueueToastActions'
import { QueueToastContentProps } from './queueToastTypes'
import { QueueData, QueueStatus } from '../../hooks/queue/queueTypes'
import { useTranslation } from 'react-i18next'
import ToastDismiss from './ToastDismiss'

type EmailFilingQueueData = QueueData<EmailFilingParams, object, object>

function getEmailFilingToastMessage({ status, context }: EmailFilingQueueData, translate: (key: string, options?: any) => string) {
    const referencesString = context.data.references.join(', ')

    return new Map<QueueStatus, ReactElement | string>([
        [QueueStatus.Dispatch, translate('toast.email.dispatch')],
        [
            QueueStatus.Queued,
            translate('toast.email.queued', {
                count: context.data.references.length,
                referencesString: referencesString,
            }),
        ],
        [QueueStatus.Delayed, translate('toast.email.delayed')],
        [QueueStatus.Cancelled, translate('toast.email.cancelled')],
        [
            QueueStatus.Finished,
            translate('toast.email.finished', {
                count: context.data.references.length,
                referencesString: referencesString,
            }),
        ],
        [QueueStatus.Failed, translate('toast.email.failed')],
        [
            QueueStatus.Duplicate,
            translate('toast.email.duplicate', {
                count: context.data.references.length,
                referencesString: referencesString,
            }),
        ],
    ]).get(status.current)
}

export default function EmailFilingToastContent(props: QueueToastContentProps): ReactElement {
    const { t: translate } = useTranslation()

    const job = props.job as EmailFilingQueueData

    return (
        <Toast>
            <ToastTitle action={<ToastDismiss />}>{getEmailFilingToastMessage(job, translate)}</ToastTitle>
            {job.status.error && (
                <ToastBody>
                    <ErrorPopover error={job.status.error} />
                </ToastBody>
            )}
            <ToastFooter>
                <QueueToastActions id={props.id} job={props.job} />
            </ToastFooter>
        </Toast>
    )
}
